<main>

  @if (elegivel==0) {
    <div class="container">
      <div class="row">
        <div class="col-md-6 alert alert-warning" style="margin: 0 auto;" role="alert">
          Seguro não disponível para a sua faixa etária (disponível apenas para participantes de 14 a 65 anos)
        </div>
      </div>
    </div>
  }

  @if (elegivel==1) {
    <div class="container">
      <ul class="nav nav-pills nav-fill" id="tabAdesaoSeguro">
        <li class="nav-item">
          <a class="nav-link active disabled" data-toggle="tab" id="btnTab1" href="#tab-1">1- Conhecendo o Seguro</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" data-toggle="tab" id="btnTab2" href="#tab-2">2- Personalizar</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" data-toggle="tab" id="btnTab3" href="#tab-3">3- Declaração de Saúde</a>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" data-toggle="tab" id="btnTab4" href="#tab-4">4- Proposta de Adesão</a>
        </li>
      </ul>
      <div class="tab-content" id="tabAdesaoSeguroContent">
        <div class="tab-pane fade show active p-4" id="tab-1">
          <app-tab1-sobre></app-tab1-sobre>
        </div>
        <div class="tab-pane fade p-4" id="tab-2">
          <app-tab2-personalizar #tab2 (eventoSalvar)="tab4.carregarResumo()"></app-tab2-personalizar>
        </div>
        <div class="tab-pane fade p-4" id="tab-3">
          <app-tab3-declaracao-saude (eventoSalvar)="tab4.carregarResumo(); tab4.CarregarDeclaracaoDeSaude();" [idcAposentado]="tab2.form.get('idcAposentado').value"></app-tab3-declaracao-saude>
        </div>
        <div class="tab-pane fade p-4" id="tab-4">
          <app-tab4-finalizar-adesao #tab4></app-tab4-finalizar-adesao>
        </div>
      </div>
    </div>
  }
</main>